import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'skl-bottom-navigation',
    template: `
        <div class="bottom-navigation">
            <ng-content />
        </div>
    `,
    styles: `
        :host {
            display: none;
            position: relative;
            height: 4rem;
            width: 100%;
            transition: display 0.3s ease-in-out;
            transition-behavior: allow-discrete;

            @media only screen and (max-width: 48rem) {
                display: flex;
            }
        }

        .bottom-navigation {
            display: flex;
            position: fixed;
            bottom: 0;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            height: 4rem;
            width: 100%;
            background-color: var(--surface-3-color);
            border-top: 1px solid var(--surface-4-color);
            opacity: 0;
            transform: translateY(100%);
            transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

            @media only screen and (max-width: 48rem) {
                opacity: 1;
                transform: translateY(0);

                @starting-style {
                    opacity: 0;
                    transform: translateY(100%);
                }
            }

            @media (prefers-reduced-motion: reduce) {
                transform: none;
                transition: opacity 0.2s;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomNavigationComponent {
}
